import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "./CommonInterfaces";

export interface DosyaBorcluIsyeriSgkTalep {
    dosyaId: string | number,
    kisiKurumId: number,
    sorguBakiye: number | string,
}

export interface DosyaBorcluIsyeriSgkCevap extends ISorguSonuc<IDosyaBorcluIsyeriSgkSonuc> {}

export interface IDosyaBorcluIsyeriSgkSonuc {
    isYeriBilgi: IIsYeriBilgi,
    sskBilgiDetay: IIsYeriBilgi
}

export interface IIsYeriBilgi {
    hataKodu: number,               // 0: başarılı 995: kayıt bulunamadı
    isyeriList: Array<IIsyeri>,
    hataMesaji?: string
}

export interface IIsyeri {
    TE_ADRES1: string,
    TE_ADRES2: string,
    TE_ADRES3: string,
    TE_ADRES4: string,
    TE_CHECK_DIGIT: string,
    TE_DIS_KAPI: string,
    TE_ESKI_SUBE_KOD: string,
    TE_IC_KAPI: string,
    TE_ILCE_KOD: string,
    TE_ILKOD: string,
    TE_ISKOLU_KOD: string,
    TE_ISYERI_UNVAN: string,
    TE_KANKAPAL_TAR: string,
    TE_MAHIYET: string,
    TE_MAHIYET_KOD: string,
    TE_SIRANO: string,
    TE_STATUS_STRING: string,
    TE_TESCIL_TIP: string,
    TE_UNVAN1: string,
    TE_UNVAN2: string,
    TE_UNVAN3: string,
    TE_YENI_SUBE_KOD: string,
    yoneticiler: Array<IYonetici>
}

export interface IYonetici {
    TY_AD: string,
    TY_ANA_AD: string,
    TY_BABA_AD: string,
    TY_CINSIYET: string,
    TY_CINSIYET_ACIKLAMA: string,
    TY_DOGUM_TARIH: string,
    TY_DOGUM_YER: string,
    TY_ESKI_SUBE_KOD: string,
    TY_ILKOD: string,
    TY_MERNIS_NO: string,
    TY_SIRANO: string,
    TY_SOYAD: string,
    TY_UNVAN: string,
    TY_UYRUK: string,
    TY_YENI_SUBE_KOD: string,
    TY_YKOD: string,
    TY_YKOD_ACIKLAMA: string
}

export default class DosyaBorcluIsyeriSgk extends UyapRequest<DosyaBorcluIsyeriSgkTalep, DosyaBorcluIsyeriSgkCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya borçlu işyeri SGK bilgileri sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "DosyaBorcluIsyeriSgk_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2IuXpdpAdThuchFVBCQ+3yaRwsqDA8Aqxs@85O9Q51fsg","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"25/04/2024 13:02","sorguSonucDVO":{"yoneticiBilgileri":{"isyeriList":[{"TE_ADRES1":"DEMETEVLER 4.CAD","TE_ADRES2":"NO.77/C","TE_ADRES3":"ANKARA","TE_ADRES4":"YENİMAHALLE","TE_CHECK_DIGIT":"30","TE_DIS_KAPI":"1","TE_ESKI_SUBE_KOD":"01","TE_IC_KAPI":"0","TE_ILCE_KOD":"21","TE_ILKOD":"06","TE_ISKOLU_KOD":"1629","TE_ISYERI_UNVAN":"AHMETİ MÜNÜR YALÇINALP","TE_KANKAPAL_TAR":"2005-01-19","TE_MAHIYET":"TABLO ALIM SATIM VE ÇERÇEVE İM","TE_MAHIYET_KOD":"2","TE_SIRANO":"1109933","TE_STATUS_STRING":"000000000000000","TE_TESCIL_TIP":"1","TE_UNVAN1":"AHMETİ MÜN","TE_UNVAN2":"ÜR YALÇINALP","TE_UNVAN3":"","TE_YENI_SUBE_KOD":"01","yoneticiler":[{"TY_AD":"AHMETİ MÜNÜR","TY_ANA_AD":"ŞADİYE","TY_BABA_AD":"ABDULKADİR","TY_CINSIYET":"E","TY_CINSIYET_ACIKLAMA":"ERKEK","TY_DOGUM_TARIH":"25.08.1957","TY_DOGUM_YER":"SİVAS","TY_ESKI_SUBE_KOD":"01","TY_ILKOD":"006","TY_MERNIS_NO":"47161224210","TY_SIRANO":"1109933","TY_SOYAD":"YALÇINALP","TY_UNVAN":"","TY_UYRUK":"TC","TY_YENI_SUBE_KOD":"01","TY_YKOD":"I","TY_YKOD_ACIKLAMA":"İŞVEREN"}]}],"hataKodu":0},"isYeriBilgi":{"isyeriList":[{"TE_ADRES1":"DEMETEVLER 4.CAD","TE_ADRES2":"NO.77/C","TE_ADRES3":"ANKARA","TE_ADRES4":"YENİMAHALLE","TE_CHECK_DIGIT":"30","TE_DIS_KAPI":"1","TE_ESKI_SUBE_KOD":"01","TE_IC_KAPI":"0","TE_ILCE_KOD":"21","TE_ILKOD":"06","TE_ISKOLU_KOD":"1629","TE_ISYERI_UNVAN":"AHMETİ MÜNÜR YALÇINALP","TE_KANKAPAL_TAR":"2005-01-19","TE_MAHIYET":"TABLO ALIM SATIM VE ÇERÇEVE İM","TE_MAHIYET_KOD":"2","TE_SIRANO":"1109933","TE_STATUS_STRING":"000000000000000","TE_TESCIL_TIP":"1","TE_UNVAN1":"AHMETİ MÜN","TE_UNVAN2":"ÜR YALÇINALP","TE_UNVAN3":"","TE_YENI_SUBE_KOD":"01","yoneticiler":[{"TY_AD":"AHMETİ MÜNÜR","TY_ANA_AD":"ŞADİYE","TY_BABA_AD":"ABDULKADİR","TY_CINSIYET":"E","TY_CINSIYET_ACIKLAMA":"ERKEK","TY_DOGUM_TARIH":"25.08.1957","TY_DOGUM_YER":"SİVAS","TY_ESKI_SUBE_KOD":"01","TY_ILKOD":"006","TY_MERNIS_NO":"47161224210","TY_SIRANO":"1109933","TY_SOYAD":"YALÇINALP","TY_UNVAN":"","TY_UYRUK":"TC","TY_YENI_SUBE_KOD":"01","TY_YKOD":"I","TY_YKOD_ACIKLAMA":"İŞVEREN"}]}],"hataKodu":0}},"sorgulamaTuru":"SSK İş Yeri Bilgisi","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false}
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_sgk_isYeriBilgileri.ajx';
    }

    async parse(data: any): Promise<DosyaBorcluIsyeriSgkCevap> {
        if (data.sorguSonucu && data.sorguSonucDVO.isYeriBilgi.hataKodu == 0)
            data.message = "İşyeri bilgisi bulundu";
        else
            data.message = data.sorguSonucDVO.isYeriBilgi.hataMesaji;
        return data;
    }

}

